import React, { useMemo } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Images from 'gatsby-image';
import PropTypes from 'prop-types';

const Photo = ({ src, ...rest }) => {
  const data = useStaticQuery(graphql`
    query {
      images: allFile(
        filter: { internal: { mediaType: { regex: "/image/" } } }
      ) {
        edges {
          node {
            relativePath
            extension
            publicURL
            childImageSharp {
              fluid(maxWidth: 1080 ,quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `);

  const match = useMemo(
    () => data.images.edges.find(({ node }) => src === node.relativePath),
    [data, src]
  );

  if (!match) return null;

  const { node: { childImageSharp, publicURL, extension } = {} } = match;

  if (extension === 'svg' || !childImageSharp || extension === 'png' || !childImageSharp || extension === 'gif') {
    return <img src={publicURL} {...rest} />;
  }

  return <Images fluid={childImageSharp.fluid} {...rest} />;
};

Photo.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
};

export default Photo;